import { render, staticRenderFns } from "./drug.vue?vue&type=template&id=c39a226a&scoped=true"
import script from "./drug.vue?vue&type=script&lang=js"
export * from "./drug.vue?vue&type=script&lang=js"
import style0 from "./drug.vue?vue&type=style&index=0&id=c39a226a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39a226a",
  null
  
)

export default component.exports